export const OTP_EXPIRED_CREATE_ACCOUNT_MESSAGE = "OTP has expired.";
export const PREVIOUS_PASSWORD_MESSAGE =
    "Password must not be the same as your previous password.";

export const isPreviousPasswordMessage = (raw = "") => {
    const lower = String(raw || "").toLowerCase();
    return (
        lower.includes("previous") ||
        (lower.includes("password") &&
            lower.includes("same") &&
            !lower.includes("username"))
    );
};

export const isExpiredRegisterTokenMessage = (raw = "") => {
    const lower = String(raw || "").toLowerCase();
    return (
        lower.includes("token entry does not exist") ||
        (lower.includes("token") && lower.includes("expired")) ||
        (lower.includes("otp") && lower.includes("expired"))
    );
};

export const handleError = (err) => {
    return {...err?.error, error: err?.error || err?.data, code: err?.status || 400}
}

export const toFriendlyApiErrorMessage = (raw = "") => {
    const text = String(raw || "").trim();
    if (!text) return "";
    const lower = text.toLowerCase();

    if (
        lower.includes("string length must be greater than or equal to 1") ||
        lower.includes("invalid request body") ||
        (lower.includes("must not be empty") && lower.includes("request body"))
    ) {
        return "Please fill in all required fields.";
    }

    if (
        lower.includes("invalid credentials") ||
        lower.includes("invalid username") ||
        lower.includes("invalid password")
    ) {
        return "Unable to login due to invalid credentials. Please try again with the correct username and password.";
    }

    if (lower.includes("account is locked") || lower.includes("locked due to")) {
        return "Account is locked due to multiple incorrect password attempts. Please reset the password and try again.";
    }

    if (lower.includes("password has expired") || lower.includes("password expired")) {
        return "Password has expired. Please reset the password and try again.";
    }

    if (
        lower.includes("email") &&
        (lower.includes("already") || lower.includes("in use") || lower.includes("exists") || lower.includes("duplicate"))
    ) {
        return "Email already in use";
    }

    if (
        lower.includes("mobile") &&
        (lower.includes("already") || lower.includes("in use") || lower.includes("exists") || lower.includes("duplicate"))
    ) {
        return "Mobile number already in use";
    }

    if (
        lower.includes("already in use") ||
        lower.includes("already exists") ||
        lower.includes("already registered") ||
        lower.includes("user already")
    ) {
        return "Email already in use";
    }

    if (lower.includes("unable to fetch user record")) {
        return "Unable to create account. Please verify the details and try again.";
    }

    if (isPreviousPasswordMessage(lower)) {
        return PREVIOUS_PASSWORD_MESSAGE;
    }

    if (isExpiredRegisterTokenMessage(lower)) {
        return OTP_EXPIRED_CREATE_ACCOUNT_MESSAGE;
    }

    if (lower.includes("forbidden via this client") || lower.includes("user creation forbidden")) {
        return "User creation is not allowed for this app.";
    }

    return text;
};

export const getApiErrorMessage = (errorPayload) => {
    if (!errorPayload) {
        return "Unknown error, please try again later.";
    }

    if (typeof errorPayload === "string") {
        return toFriendlyApiErrorMessage(errorPayload);
    }

    const apiError = errorPayload?.error ?? errorPayload;

    if (typeof apiError === "string") {
        return toFriendlyApiErrorMessage(apiError);
    }

    if (apiError?.message) {
        return toFriendlyApiErrorMessage(apiError.message);
    }

    if (errorPayload?.message) {
        return toFriendlyApiErrorMessage(errorPayload.message);
    }

    if (errorPayload?.code) {
        const detail =
            (typeof errorPayload?.error === "string" && errorPayload.error) ||
            errorPayload?.error?.message ||
            errorPayload?.statusText ||
            "";
        if (detail) {
            return toFriendlyApiErrorMessage(detail);
        }
        return `Request failed (${errorPayload.code}). No error details from server.`;
    }

    return "Unknown error, please try again later.";
}